import React,{useState,useEffect} from "react";
import '../styles/skills.css';
import {AiOutlineArrowLeft, AiOutlineArrowRight} from 'react-icons/ai';
const me = require("../shared/about.json");

const pi = ["pink","lighblue","pink","lighblue","lightgreen"];
export default function Skills(){
    const [index,setIndex] = useState(0);

    const funcInc=()=>{
        if(index<=4){
            setIndex(index+1);
            document.getElementById("btn1").disabled=false;

        }
        else{
            document.getElementById("btn2").disabled=true;
        }
    }
    const funcDec=()=>{
        if(index>0){
            setIndex(index-1);
            document.getElementById("btn2").disabled=false;
        }
        else{
            document.getElementById("btn1").disabled=true;
        }
    }
    return(
        <>
        <div className="maincontent">
                <div className="head">
                    <h1>{me.head[index]}</h1>
                </div>    
                <div className="body">
                    <img alt="something" src={me.body[index]}/>
                </div>
        </div>
        
        <div className="sfoot">
        <button id="btn1" onClick={()=>funcDec()}>
            <AiOutlineArrowLeft/>
        </button>
        <button id="btn2" onClick={()=>funcInc()}>
            <AiOutlineArrowRight/>
        </button>
    </div>
    </>
    );
}